import findPosts from '../components/postsFilter';
import Glide from '@glidejs/glide';

(function ($) {
	$(document).ready(function ($) {
		let experiencesTitle = $('.experiencies__title');
		let wrapperElement = $('.experiencies__content__wrapper');
		let wrapperElementMobile = $('.experiencies__content__wrapper__mobile');
		let thereIsAMobileWrapper = $('.mobile-wrapper-flag').val();
		let wrapperSelects = $('.experiencies__selects__wrapper');
		let categoriesSelect = $('#categories-select');
		let municipalitiesSelect = $('#municipalities-select');
		let observer = document.getElementById('observer-experiencies');

		let requestData = {
			postType: 'experiencia',
			taxonomy: 'categorias_de_experiencia',
			currentPage: 1,
			postsPerPage: 5
		};

		wrapperSelects.change(function () {
			requestData.category = categoriesSelect.val();
			requestData.municipality = municipalitiesSelect.val();
			requestData.currentPage = 1;

			let municipalitiesSelectedOption = $('#municipalities-select option:selected');
			let CategoriesSelectedOption = $('#categories-select option:selected');

			if (categoriesSelect.val()) {
				experiencesTitle.html(
					`Experiencias ${CategoriesSelectedOption.data(
						'legend'
					)} <img src="/wp-content/themes/compas/src/img/check.svg" alt="Ícono experiencias">`
				);
			}

			if (categoriesSelect.val() && municipalitiesSelect.val()) {
				experiencesTitle.html(
					`Experiencias ${CategoriesSelectedOption.data(
						'legend'
					)} en ${municipalitiesSelectedOption.text()} <img src="/wp-content/themes/compas/src/img/check.svg" alt="Ícono experiencias">`
				);
			}

			if (!categoriesSelect.val() && municipalitiesSelect.val()) {
				experiencesTitle.html(
					`Experiencias en ${municipalitiesSelectedOption.text()} <img src="/wp-content/themes/compas/src/img/check.svg" alt="Ícono experiencias">`
				);
			}

			if (!categoriesSelect.val() && !municipalitiesSelect.val()) {
				experiencesTitle.html(
					`Experiencias <img src="/wp-content/themes/compas/src/img/check.svg" alt="Ícono experiencias">`
				);
			}

			if (observer) {
				intersectionObserver.unobserve(observer);
			}

			findPosts(requestData, responseExperiencies, 'overwrite', wrapperElement);
		});

		const intersectionObserver = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					requestData.currentPage++;

					if (observer) {
						intersectionObserver.unobserve(observer);
					}

					findPosts(requestData, responseExperiencies, 'append', wrapperElement);
				}
			},
			{
				rootMargin: '0px'
			}
		);

		if (observer) {
			intersectionObserver.observe(observer);
		}

		function responseExperiencies(res) {
			let windowWidth = $(window).width();
			let isMobile = thereIsAMobileWrapper && windowWidth <= 576;

			if (isMobile) {
				wrapperElement = wrapperElementMobile;
			}

			if (res.length) {
				let html = '';
				let htmlSliderBullets = '';

				res.forEach((element, index) => {
					if (isMobile) {
						html += renderExperienceMobile(element);
						htmlSliderBullets += `
							<button class="glide__bullet" data-glide-dir="=${index}"></button>
						`;
					} else {
						html += renderExperience(element);
					}
				});

				if (requestData.currentPage === 1) {
					if (isMobile) {
						wrapperElement.html(`
							<div class="glide-municipality-experiences">
								<div class="glide__track" data-glide-el="track">
									<ul class="glide__slides">
										${html}
									</ul>
								</div>
								<div class="glide__bullets" data-glide-el="controls[nav]">
									${htmlSliderBullets}
								</div>
							</div>
							
						`);

						let municipalityExperienciesSlider = document.querySelector(
							'.municipality__experiences__glide.mobile'
						);

						if (municipalityExperienciesSlider) {
							let glideExperiencia = new Glide('.municipality__experiences__glide.mobile', {
								type: 'carousel',
								perView: 1.125,
								gap: '15px'
							});
							glideExperiencia.mount();
						}
					} else {
						wrapperElement.html(html);
					}

					if (observer) {
						intersectionObserver.observe(observer);
					}
				} else {
					wrapperElement.append(html);

					if (observer) {
						intersectionObserver.observe(observer);
					}
				}
			} else {
				if (requestData.currentPage === 1) {
					wrapperElement.html(
						'<p class="not-found-message">No existen experiencias que coincidan con la búsqueda</p>'
					);
				}
				if (observer) {
					intersectionObserver.unobserve(observer);
				}
			}

			$('.posts-filter__loading-message').remove();
		}

		function renderExperience(element) {
			let html = `
				<a href="${element.permalink}" class="experiencies__content__wrapper__item">
					<img class="experiencies__content__wrapper__item__icon" src="${element.check}" alt="Ícono experiencias">
					${element.thumbnail}
					<div class="experiencies__content__wrapper__item__info">
						<h2>${element.title}</h2>
						<p>
							<span>
								${
									element.municipio
										? `
											<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M15.9998 0.833984C11.9596 0.833782 8.08258 2.42819 5.21139 5.27067C2.3402 8.11315 0.706906 11.974 0.666504 16.014C0.666504 26.5173 14.179 38.209 14.754 38.7073C15.1012 39.0043 15.543 39.1674 15.9998 39.1674C16.4567 39.1674 16.8985 39.0043 17.2457 38.7073C17.9165 38.209 31.3332 26.5173 31.3332 16.014C31.2928 11.974 29.6595 8.11315 26.7883 5.27067C23.9171 2.42819 20.0401 0.833782 15.9998 0.833984ZM15.9998 21.9173C14.6731 21.9173 13.3761 21.5239 12.2729 20.7868C11.1697 20.0496 10.3099 19.0019 9.80215 17.7762C9.29441 16.5504 9.16156 15.2015 9.4204 13.9003C9.67924 12.599 10.3182 11.4037 11.2563 10.4655C12.1945 9.5273 13.3898 8.88839 14.6911 8.62955C15.9924 8.37071 17.3412 8.50355 18.567 9.01129C19.7928 9.51903 20.8405 10.3789 21.5776 11.482C22.3147 12.5852 22.7082 13.8822 22.7082 15.209C22.7082 16.9881 22.0014 18.6944 20.7433 19.9525C19.4853 21.2105 17.779 21.9173 15.9998 21.9173Z" fill="#FFFFFF"/>
											</svg>
											${element.municipio}
										`
										: ''
								}
							</span>
							<span>
								${
									element.fields.duracion
										? `
											<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												<path d="M10.75 11.5L8.9395 9.6895C8.65818 9.40826 8.50008 9.02679 8.5 8.629L8.5 4" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
											${element.fields.duracion}
										`
										: ''
								}
							</span>
						</p>
					</div>
				</a>
			`;
			return html;
		}

		function renderExperienceMobile(element) {
			let html = `
				<li class="glide__slide">
					<a href="${element.permalink}" class="experiencies__content__wrapper__item">
						<img src="${element.check}" class="experiencies__content__wrapper__item__icon" alt="Ícono experiencias">
						${element.thumbnail}
						<div class="experiencies__content__wrapper__item__info">
							<h2>${element.title}</h2>
							<p>
								<span>
									${
										element.municipio
											? `
												<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M15.9998 0.833984C11.9596 0.833782 8.08258 2.42819 5.21139 5.27067C2.3402 8.11315 0.706906 11.974 0.666504 16.014C0.666504 26.5173 14.179 38.209 14.754 38.7073C15.1012 39.0043 15.543 39.1674 15.9998 39.1674C16.4567 39.1674 16.8985 39.0043 17.2457 38.7073C17.9165 38.209 31.3332 26.5173 31.3332 16.014C31.2928 11.974 29.6595 8.11315 26.7883 5.27067C23.9171 2.42819 20.0401 0.833782 15.9998 0.833984ZM15.9998 21.9173C14.6731 21.9173 13.3761 21.5239 12.2729 20.7868C11.1697 20.0496 10.3099 19.0019 9.80215 17.7762C9.29441 16.5504 9.16156 15.2015 9.4204 13.9003C9.67924 12.599 10.3182 11.4037 11.2563 10.4655C12.1945 9.5273 13.3898 8.88839 14.6911 8.62955C15.9924 8.37071 17.3412 8.50355 18.567 9.01129C19.7928 9.51903 20.8405 10.3789 21.5776 11.482C22.3147 12.5852 22.7082 13.8822 22.7082 15.209C22.7082 16.9881 22.0014 18.6944 20.7433 19.9525C19.4853 21.2105 17.779 21.9173 15.9998 21.9173Z" fill="#FFFFFF"/>
												</svg>
												${element.municipio}
											`
											: ''
									}
								</span>
								<span>
									${
										element.fields.duracion
											? `
												<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													<path d="M10.75 11.5L8.9395 9.6895C8.65818 9.40826 8.50008 9.02679 8.5 8.629L8.5 4" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
												${element.fields.duracion}
											`
											: ''
									}
								</span>
							</p>
						</div>
					</a>
				</li>
			`;
			return html;
		}
	});
})(jQuery);
